import {Button, Message, Modal} from 'semantic-ui-react'
import React from 'react'

export function WarningMessage(props) {
    return (
        <Message className='theEnd' visible warning>
            <Message.Header>{props.header}</Message.Header>
            <p>{props.message}</p>
        </Message>
    )
}


export function SessionInformation(props) {
    // const public_link = props.sessionIdPublic + '#' + props.sessionIdPrivate;
    const public_link = window.location + '?view=' + props.sessionIdPublic;
    return (
        <Modal trigger={<Button>Share session to observers</Button>}>
            <Modal.Header>Share the following link to the observers</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <a href={public_link}>{public_link}</a>
                </Modal.Description>
            </Modal.Content>
        </Modal>
    )
}

